export enum EnumSystemEvent {
  LOCKED = 'locked',
  UNLOCKED = 'unlocked',
  /** Устройство перешло в другое рабочее место */
  WORKSPACE_CHANGED = 'workspace_changed',
}
